<template>
  <div
    v-show="show"
    class="absolute w-full h-full grid place-items-center cursor-default"
  >
    <div class="absolute bg-gray-500 opacity-40 inset-0 z-10" />
    <div
      class="absolute cursor-default bg-sky-500 border-sky-600 block text-white font-bold rounded-lg py-2 lg:py-3 px-2 sm:px-0 w-24 text-xs sm:w-32 sm:text-lg lx:w-40 lg:text-base -rotate-5 z-20 shadow-lg"
      v-text="text"
    />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },

    text: {
      type: String,
      required: true,
    },
  },
};
</script>
